/* eslint-disable */
//tslint:disable

export interface IParkingItemSchema {
  /** Значение **/
  title: string;
  /** Тип парковки **/
  type: EType;
}

export enum EType {
  /** Гостевая **/
  Guest = 'guest',
  /** Отдельная многоуровневая **/
  Standalone = 'standalone',
  /** Подземная **/
  Underground = 'underground',
}
